<template>
  <div>
    <cell
      v-show="showCell"
      :title="title"
      primary="content"
      is-link
      :inline-desc="inlineDesc"
      :value-text-align="valueTextAlign"
      @click.native="onClick">
      <span class="vux-popup-picker-value" v-if="!showName && value.length && !showSecondName">{{value | array2string}}</span>
      <span class="vux-popup-picker-value" v-else-if="showName && value.length && !showSecondName">{{value | value2name(data)}}</span>
      <span class="vux-popup-picker-value" v-if="showSecondName && value.length">{{ getSecondNameValues(value, data)}}</span>
      <span class="cvux-popup-placeholder" v-if="!value.length && placeholder" v-html="placeholder"></span>
    </cell>
    <popup
      v-model="showValue"
      class="vux-popup-picker"
      :id="`vux-popup-picker-${uuid}`"
      @on-hide="onPopupHide"
      @on-show="$emit('on-show')">
      <div class="vux-popup-picker-container">
        <div class="vux-popup-picker-header">
          <flexbox>
            <flexbox-item class="vue-popup-cancel" @click.native="onHide(false)">取消</flexbox-item>
            <flexbox-item class="vue-popup-confirm" @click.native="onHide(true)">完成</flexbox-item>
          </flexbox>
        </div>
        <picker :data="data"
        v-model="tempValue"
        @on-change="onPickerChange"
        :columns="columns"
        :fixed-columns="fixedColumns"
        :container="`#vux-popup-picker-${uuid}`"
        :id="id"></picker>
      </div>
    </popup>
  </div>
</template>

<script>
import Picker from '../picker'
import Cell from '../cell'
import Popup from '../popup'
import Flexbox from '../flexbox'
import FlexboxItem from '../flexbox-item'
import array2string from '../../filters/array2String'
import value2name from '../../filters/value2name'
import uuidMixin from '../../libs/mixin_uuid'

const getObject = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}

export default {
  created () {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show
    }
  },
  mixins: [uuidMixin],
  components: {
    Picker,
    Cell,
    Popup,
    Flexbox,
    FlexboxItem
  },
  filters: {
    array2string,
    value2name
  },
  props: {
    title: String,
    data: {
      type: Array,
      default () {
        return []
      }
    },
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default () {
        return []
      }
    },
    showName: Boolean,
    inlineDesc: String,
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    id: {
      type: String,
      default: ''
    },
    showSecondName: Boolean
  },
  methods: {
    getNameValues () {
      return value2name(this.currentValue, this.data)
    },
    onClick () {
      this.showValue = true
    },
    onHide (type) {
      this.showValue = false
      if (type) {
        this.closeType = true
        this.currentValue = getObject(this.tempValue)
      }
      if (!type) {
        this.closeType = false
        if (this.currentValue.length > 0) {
          this.tempValue = getObject(this.currentValue)
        }
      }
    },
    onPopupHide (val) {
      if (this.value.length > 0) {
        this.tempValue = getObject(this.currentValue)
      }
      this.$emit('on-hide', this.closeType)
    },
    onPickerChange (val) {
      if (JSON.stringify(this.currentValue) !== JSON.stringify(val)) {
        // if has value, replace it
        if (this.value.length) {
          const nowData = JSON.stringify(this.data)
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = getObject(val)
          }
          this.currentData = nowData
        } else { // if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      this.$emit('on-shadow-change', getObject(val))
    },
    getSecondNameValues(value, list) {
      let nameStr = value2name(value, list)
      return nameStr.split(' ')[1]
    }
  },
  watch: {
    value (val) {
      if (JSON.stringify(val) !== JSON.stringify(this.tempValue)) {
        this.tempValue = getObject(val)
      }
    },
    currentValue (val) {
      this.$emit('on-change', getObject(val))
      this.$emit('input', getObject(val))
    },
    show (val) {
      this.showValue = val
    }
  },
  data () {
    return {
      tempValue: getObject(this.value),
      closeType: false,
      currentData: JSON.stringify(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    }
  }
}
</script>

<style lang="less">
@import '../../styles/cui/widget/cui_cell/cui_cell_global';
.vux-popup-picker {
  border-top: 1px solid #04BE02;
}
.vux-popup-picker-header {
  height: 44/@w;
  color: #5890ff;
}
.vux-popup-picker-value {
  display: inline-block;
}
.vue-popup-cancel{
  text-align:left;padding-left:15/@w;line-height:44/@w;
  color: #000;
}
.vue-popup-confirm{
  text-align:right;padding-right:15/@w;line-height:44/@w;
}
.cvux-popup-placeholder {
  color: #a0a0a0;
}
</style>



// WEBPACK FOOTER //
// popup-picker.vue?16ac44a8